export default __webpack_public_path__ + "static/media/deloralogo.bd56d689.jpg";